<template>
  <div>
    <px-view-header title="Aprovações" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <listagem-aprovacao-header :on-click-refresh="onClickRefresh"
                               :on-change-filter="onChangeFilter"
                               @change="onChangeFilter"/>
    <lista-aprovacao :aprovacoes="aprovacoes" :loading="loading"
                     :on-change-options="onChangeOptions"
                     :options-list="optionsList"
                     @update="onClickRefresh"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AprovacaoService from '@/modules/aprovacao/aprovacao-service';
import ListaAprovacao from '@/modules/aprovacao/listagem/ListaAprovacao.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import ListagemAprovacaoHeader from '@/modules/aprovacao/listagem/ListagemAprovacaoHeader.vue';

export default {
  mixins: [paginationMixin],
  computed: {
    ...mapGetters('listagemAprovacao', ['stringFilter']),
  },
  data() {
    return {
      aprovacoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Aprovações' },
      ],
    };
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getAprovacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getAprovacoes();
    },
    onClickRefresh() {
      this.getAprovacoes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getAprovacoes() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      return AprovacaoService.getAprovacoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.aprovacoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: { ListaAprovacao, ListagemAprovacaoHeader },
};
</script>
